var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"physmap"}},[_c('GmapMap',{ref:"physicianMap",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.default_center,"zoom":_vm.default_zoom,"options":_vm.mapOptions,"map-type-id":"roadmap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }